import { WorksheetBaseModel } from './worksheet-base-model';

export class WorksheetModel extends WorksheetBaseModel {
    worksheetData: any;
    controlsDict: {};
    path: string;

    constructor(options: { parent?: WorksheetBaseModel } = {}) {
        super(options);
    }

    categorizeControls(data: any) {
        this.worksheetData = data;
        this.path = data.Path;

        this.controlsDict = {};

        if (this.worksheetData != null) {
            this.populateControlsDict(this.worksheetData);
        }
    }

    addToControlsDict(key: string, value: any) {
        if (this.controlsDict[key] === undefined) {
            this.controlsDict[key] = value;
        }
    }

    populateControlsDict = (worksheetData: any) => {
        this.populateControlsDictSection('form', worksheetData, null, 0);

        this.populateControlsDictSection('results', worksheetData, null, 0);

        this.populateControlsDictSection('diagnosis', worksheetData, null, 0);
    }

    populateControlsDictSection = (itemType: string, worksheetData: any, control: any, depth: number) => {

        if (control === null) { // Top level

            if (itemType === 'form') {
                //this.addToControlsDict(worksheetData.ID, worksheetData);

                if (worksheetData.Categories != null) {
                    worksheetData.Categories.forEach(e => {
                        this.addToControlsDict(e.ID, e); // category

                        e.Controls.forEach(e1 => {
                            this.populateControlsDictSection(itemType, null, e1, depth); 
                        });
                    });
                }
            } else if (itemType === 'results') {
                if (worksheetData.Results != null) {
                    //this.addToControlsDict(worksheetData.Results.ID, worksheetData.Results);

                    worksheetData.Results.Controls.forEach(e1 => {
                        this.populateControlsDictSection(itemType, null, e1, depth);
                    });
                }
            } else if (itemType === 'diagnosis') {
                if (worksheetData.Diagnosis != null) {
                    //this.addToControlsDict(worksheetData.Diagnosis.ID, worksheetData.Diagnosis);

                    if (worksheetData.Diagnosis != null) {
                        worksheetData.Diagnosis.Controls.forEach(e1 => {
                            this.populateControlsDictSection(itemType, null, e1, depth);
                        });
                    }
                }
            }
        } else {
            // process controls
            if (control != null) {

                if (control.DataType === 'action') {
                    // console.log('stop');
                }
                if (control.DataType === 'stringlist' ||
                    control.DataType === 'int' ||
                    control.DataType === 'string' ||
                    control.DataType === 'bool' ||
                    control.DataType === 'multilinestring' ||
                    control.DataType === 'action') {
                    this.addToControlsDict(control.ID, control);
                }
            }
        }

        // Resursively process child controls
        if (control != null) {
            control.Controls.forEach(e3 => {
                this.populateControlsDictSection(itemType, null, e3, depth + 1); // Increment depth since these are recursive elements
            });
        }
    }
}

